import * as React from 'react';
import { Header, SubHeader, SubHeaderText } from './base';
import './changeSummarySection.module.scss';

const PointHighlight = ({ items }) => (
  <div styleName="point-highlight">
    {items.map((item, idx) => (
      <div key={idx} styleName="point-highlight-item">
        <div styleName="circle" />
        {item}
      </div>
    ))}
  </div>
);

export const ChangeSummarySection = () => (
  <div styleName="section">
    <Header>４つの特徴</Header>
    <SubHeader>1. ︎SHElikes全コースのオンラインレッスン受け放題！</SubHeader>
    <SubHeaderText>
      基礎コースのWebデザイナーコース、ライターコース、Webマーケターコースはもちろん、応用コースのワードプレスコース、ブランディングコース、広報PRコースなど全15コースが受け放題になります。
      <br />
      (応用コースは9月にリリース予定です。)
    </SubHeaderText>

    <PointHighlight
      items={[
        '現在開催中のレッスンがオンラインで受け放題に',
        '通勤中でもお家でもいつでも学べる',
        '受け放題で頑張り次第で幅広いスキルを短期間で学べる！',
      ]}
    />
    <SubHeader>2. ︎なりたい姿までサポートするグループコーチング！</SubHeader>
    <SubHeaderText>
      オンライン学習は不安…という方にぴったりの制度「グループコーチング」が新しく始まります。
    </SubHeaderText>
    <PointHighlight
      items={[
        '目標や学習計画を作成',
        '月１で振り返ることで、自分をアップデートするサポート',
        '一人じゃ頑張れないことも、仲間から刺激を受けたり目標を共有することで成し遂げやすい',
      ]}
    />
    <SubHeader>3. ︎学習の疑問を解消する「もくもく会」</SubHeader>
    <SubHeaderText>
      レッスンや課題で生まれた疑問に、講師・アシスタントがお答えするもくもく会に参加し放題になります。
    </SubHeaderText>
    <PointHighlight
      items={['オンラインでも、教室に来ても、どちらでも参加可能', 'ほぼ毎日開催', '同じ目標の仲間が見つかることも']}
    />
    <SubHeader>4. ︎特別イベントも受け放題！</SubHeader>
    <SubHeaderText>
      これまでも開催していた、「コピーライティング講座」や、「SNS活用講座」などの各種特別イベントが、受け放題になります！
    </SubHeaderText>
    <PointHighlight items={['ほぼ毎月新しいイベントを開催', '業界で注目されている方の登壇も']} />
  </div>
);
